export default __webpack_public_path__ + "3edb0a8a21691a911c204f189f7b8aa9.svg";